import { localGet, localSet } from "./storageKeys"
import { requestRender } from "../state"

const SUFFIX = "explain-mode"

/** Wave-1 explain mode: default OFF. Intent memory only — never bypasses honesty gates. */
export function isExplainMode(): boolean {
  return localGet(SUFFIX) === "1"
}

export function setExplainMode(on: boolean): void {
  localSet(SUFFIX, on ? "1" : "0")
  requestRender()
}

export function toggleExplainMode(): void {
  setExplainMode(!isExplainMode())
}
